/***********************************************
* Login.js
* 
* Handles the login of the application
***********************************************/
/* Layout files */
import '../assets/style/Login.css';

/* Global imports */
import React   from 'react';
import Popup   from 'reactjs-popup';
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { Outlet } from "react-router";
import { withTranslation }                     from 'react-i18next';

/* Local imports */
import API     from './API';
import Storage from './Storage';
import { HelpPopup } from './Popup';
import Cookie  from './Cookie';
import Header from './Header';

import createGif  from "../assets/images/Create Account noloop.gif";
import { getHomeUrl } from '../App';
  
/* Allow this component to navigate to different pages */
function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();

        return (<Component {...props} router={{ location, navigate, params }} />);
    }
  
    return ComponentWithRouterProp;
}

class Login extends React.Component {
    constructor(props) {
        super(props);
        /* Check if user is logged in */
        var user = Storage.GetToken();
        if(user == null) { user = {username: ""}; }

        this.state = {
            username: "",
            loggedInUser: user["username"],
            password: "",
            fail: false,
            checkLogin: false,
            gotoUser: false,
            gotoChanged: false,
            gifSrc: "",
        };

        this.loginSuccess = this.loginSuccess.bind(this);
        this.loginFail    = this.loginFail.bind(this);
        this.handleEnter  = this.handleEnter.bind(this);
        this.gotoUser     = this.gotoUser.bind(this);
        this.gotoCreate   = this.gotoCreate.bind(this);
    }

    /* Check every second if the user is logged in */
    componentDidMount() {
        this.interval = setInterval(() => {
            var token = Storage.GetToken();
            if(token == null){ this.setState({ checkLogin: true }); }
        }, 1000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }

    /* Request a token for a user with password */
    login()       { API.GetToken(this.state.username, this.state.password, this.loginSuccess, this.loginFail); }
    /* On success, set the state of the user */
    loginSuccess(reply){ this.setState({fail: false, username: "", password: "", loggedInUser: this.state.username}); }
    /* On fail, don't login */
    loginFail()   { this.setState({fail: true}); }

    /* On enter in the input, try logging in */
    handleEnter(event){ if(event.key === "Enter"){ this.login(); }}

    /* If clicked on the user info button, goto page /user */
    gotoUser() {
        if(this.state.gotoChanged) {
            this.setState({gotoChanged: false});
            if(this.state.gotoUser) {
                return (<Navigate to={"/user"}/>);
            } else {
                return (<Navigate to={getHomeUrl()}/>);
            }
        } else {
            return (<></>);
        }
    }

    /* If clicked on "Create Account", goto /createuser */
    gotoCreate() { 
        this.props.router.navigate("/createuser");
    }

    renderChildren() {
        return React.Children.map(this.props.children, (child) => {
            return React.cloneElement(child, { language: this.props.language });
        });
    };

    render() {
        var token = null;
        if(this.props.nologin !== true){
            token = Storage.GetToken();
            if(token != null) { token = token["userToken"]; }
        } else {
            token = "";
        }
        /* If logged in, show the geopxl page */
        if(token != null) {
            return (
                <Header language={this.props.language} barAdditions={
                    <>
                        <label>{this.props.t("welcome")} {this.state.loggedInUser}</label>
                        <Popup
                            trigger={<button className="bigButton darkButton iconButton"><span className="material-symbols-outlined">person</span></button>}
                            position="bottom right"
                            on="click"
                            closeOnDocumentClick
                            mouseLeaveDelay={300}
                            mouseEnterDelay={0}
                            contentStyle={{}}
                            arrow={false}
                            className="userPopup"
                        >
                            <div>
                                <div onClick={() => this.setState(prevState => ({gotoUser: !prevState.gotoUser, gotoChanged: true}))} className="button bigButton darkButton">{this.props.t("editprofile")}</div>
                                <div onClick={() => Storage.RemoveToken()} className="button bigButton darkButton">{this.props.t("logout")}</div>
                            </div>
                        </Popup>
                        {this.gotoUser()}
                    </>
                }>
                    <Outlet />
                </Header>
            );
        } else {  /* If not logged in, show the login page */
            return (
                <Cookie>
                <div className="loginPage">
                    <div className="logoutDiv">
                        <select name="language" id="language" className="languageSelect" value={this.props.language.active} onChange={(e) => this.props.language.set(e.target.value)}>
                            {this.props.language.list.map((lang) => <option key={lang} value={lang}>{lang}</option>)}
                        </select>
                    </div>
                    <div className="loginDiv">
                        {/*<HelpPopup position="right" gif={createGif} />*/}
                        {/*<h1 className='center photomation'>GeoPxl</h1>*/}
                        <img className='loginLogo' src="logo_top_trans.png" alt="Logo" />
                        <div className="loginFail" style={(this.state.fail) ? {display: "block"} : {display: "none"}}>{this.props.t("loginfailed")}:<br/> {this.props.t("wrongcreds")}</div>
                        <input type="text"     onChange={(e) => this.setState({username: e.target.value})} placeholder={this.props.t('username')} className="loginInput"></input>
                        <input type="password" onChange={(e) => this.setState({password: e.target.value})} placeholder={this.props.t('password')} className="loginInput" onKeyDown={this.handleEnter}></input>
                        <a href="/forgot">{this.props.t("forgot")}</a>
                        <button onClick={() => this.login()} className="bigButton loginButton">{this.props.t("login")}</button>
                        <hr />
                        <button onClick={() => this.gotoCreate()} className="bigButton createButton loginButton">{this.props.t("createaccount")}</button>
                    </div>
                </div>
                </Cookie>
            );
        }
    }
}

export default withTranslation("Login")(withRouter(Login));


export function NoLogin(props) {
    return (<Header language={props.language}>
        <Outlet />
    </Header>);
}